import { render, staticRenderFns } from "./DetectIP.vue?vue&type=template&id=7def4ae6&scoped=true&"
import script from "./DetectIP.vue?vue&type=script&lang=js&"
export * from "./DetectIP.vue?vue&type=script&lang=js&"
import style0 from "./DetectIP.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetectIP.vue?vue&type=style&index=1&id=7def4ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7def4ae6",
  null
  
)

export default component.exports